import React from "react";

const ArrowLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <g>
        <path
          d="M10.7071 -0.707107C10.3166 -1.09763 9.68341 -1.09763 9.29289 -0.707107L-0.707107 9.29289Q-0.847759 9.43355 -0.92388 9.61732Q-1 9.80109 -1 10Q-1 10.1989 -0.923879 10.3827Q-0.847759 10.5665 -0.707107 10.7071L9.29289 20.7071C9.68341 21.0976 10.3166 21.0976 10.7071 20.7071C11.0976 20.3166 11.0976 19.6834 10.7071 19.2929L1.41421 10L10.7071 0.707107C11.0976 0.316586 11.0976 -0.316586 10.7071 -0.707107Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 15.8333 10)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default ArrowLeftIcon;
